import { Icon } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React from "react";
import OtpInput from "react-otp-input";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import DenseAppBar from "../../components/AppBar";
import Filters from "../../components/Filters";
import Input from "../../components/Input";
import MetricsCard from "../../components/MetricsCard";
import AlertModal from "../../components/Modal";
import PaginationControlled from "../../components/Pagination";
import Placeholder from "../../components/Skeleton";
import StatusAlert from "../../components/StatusAlert";
import WithdrawCommissionsAlertPopup from "../../components/WithdrawCommissionsAlertPopup";
import {
  getCurrency,
  getDate,
  getDateTime,
  requestIdGenerator,
} from "../../helpers/Functions";
import { Reducers } from "../../Interfaces/Interfaces";

import {
  getAggregatorCommission,
  getCashoutAccount,
  getCordinatorDashboard,
  getAggregatorDashboard,
  withdrawToBank,
  withdrawToWallet,
  sendOtpToUser,
} from "../../redux/actions/userActions";
import PrimaryTheme from "../../Themes/Primary";
import DownloadTransactionForm from "../../components/downloadTransactionForm";
import "./comission.scss";
import WithdrawModal from "../../components/WithdrawModal/WithdrawModal";
export default function Commissions() {
  const commissions = useSelector((state: Reducers) => state.commissions);
  const dashboard: any = useSelector((state: Reducers) => state.dashboard);
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);
  const cashout = useSelector((state: Reducers) => state.cashout);
  const otp = useSelector((state: Reducers) => state.otp);
  const userType = useSelector((state: Reducers) => state.userType);
  // const coordinatorType = useSelector((state: Reducers) => state.coordinatorType);
  var [canWithdrawCommission, setCanWithdrawCommission] = React.useState(
    user.permission && user.permission.canWithdrawCommission
  );

  React.useEffect(() => {
    if (userType === "5") {
      setCanWithdrawCommission(true);
    } else {
      if (user.permission) {
        setCanWithdrawCommission(user.permission.canWithdrawCommission);
      } else {
        setCanWithdrawCommission(false);
      }
    }
  }, [canWithdrawCommission]);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [searchState, setSearchState] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [account, setAccount] = React.useState("bank");
  
  const [walletAccount, setWalletAccount] = React.useState(
    cashout && cashout.agentPhoneNumber !== null ? cashout.agentPhoneNumber : cashout.aggregatorName
  );
  // const [walletAccount, setWalletAccount] = React.useState(
  //   cashout && cashout.agentPhoneNumber ? cashout.agentPhoneNumber : ""
  // );
  const [cashoutAccount, setCashoutAccount] = React.useState(
    cashout && cashout.accountNumber
      ? cashout.agentPhoneNumber + `(${cashout.bankName})`
      : ""
  );
  const [amount, setAmount] = React.useState("");
  const [accountName, setAccountName] = React.useState(
    cashout && cashout.accountName ? cashout.accountName : ""
  );
  const [agentName, setAgentName] = React.useState(
    cashout && cashout.agentName ? cashout.agentName : ""
  );
  const [loading, setLoading] = React.useState(false);
  const [loadingCommissionCashout, setLoadingCommissionCashout] = React.useState(false);
  const [authenticate, setAuthenticate] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const [isSummary, setIsSummary] = React.useState(false);
  const [pin, setPin] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [subtitle, setSubtitle] = React.useState("");
  const [hasCashout, setCashout] = React.useState(false);
  const [handleWithDrawModal, sethandleWithDrawModal] = React.useState(false);
  const [NewCashout, setNewCashout] = React.useState(false);
  const [RefreshAfterSubmit, setRefreshAfterSubmit] = React.useState(false);
  const [validatedEntityId, setValidatedEntityId] = React.useState("");
  const [authenticationOtp, setAuthenticationOtp] = React.useState("");
  const [submittedOtp, setSubmittedOtp] = React.useState(false);
  const [isCommission, setIsCommission] = React.useState(false);
  const [isBank, setIsBank] = React.useState(false);
  const [isWallet, setIsWallet] = React.useState(false);
  const [counter, setCounter] = React.useState(60);

  let list = commissions && commissions.items;

  let filter: any = {};
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter),
  };

  const callCommissions = () => {
    dispatch(getAggregatorCommission(paginationConfig));
    dispatch(getAggregatorDashboard());
    dispatch(getCashoutAccount(user.id));
  };

  React.useEffect(() => {
    if (cashout && Object.entries(cashout).length !== 0) {
      setCashout(true);
      if (cashout.hasCashoutAccount) {
        setNewCashout(true);
      } else {
        setNewCashout(false);
      }
    } else {
      setCashout(false);
      setNewCashout(false);
    }
  }, [cashout]);

  React.useEffect(() => {
    if (searchState.length >= 3) {
      filter.agentName = searchState;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });
      callCommissions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, searchState]);

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    setPageSize(value.props.value);

    paginationConfig.pageSize = value.props.value;
    callCommissions();
    dispatch({
      type: "LOADING",
      payload: true,
    });
  };

  const handleClear = () => {
    filter = {};
    paginationConfig.whereCondition = JSON.stringify(filter);
    setSearchState("");

    dispatch({
      type: "LOADING",
      payload: true,
    });

    callCommissions();
  };

  const handleRefresh = () => {
    dispatch({
      type: "LOADING",
      payload: true,
    });

    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });
    dispatch({
      type: "ALERT",
      payload: true,
    });
    setNewCashout(false)
    setAuthenticate(false)
    setAuthenticationOtp('')
    setIsCommission(false)
    setIsBank(false)
    setIsWallet(false)
    setSubmitted(false)
    setSubmittedOtp(false)
    callCommissions();

  };

  // const handleWithdrawal = () => {
  //   sethandleWithDrawModal(false);
  //   dispatch({
  //     type: "ALERT_MODAL",
  //     payload: true,
  //   });
  // };
  const handleWithdrawal = () => {
    sethandleWithDrawModal(false);
    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
  };

  const closeModal = () => {
    
    setLoading(false);
    setSubmitted(false);
    setPin("");
    setIsSummary(false)
    setAmount("");
    setLoadingCommissionCashout(false)
    dispatch({ type: "ALERT_MODAL", payload: false });
  };
  const closePinModal = () => {    
    setLoading(false);
    setPin("");
    setIsSummary(false)
    setAmount("");
    dispatch({ type: "ALERT_MODAL", payload: false });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    setLoading(true);
    setSubmitted(true);
    setIsWallet(true)
    setIsCommission(true)

    const data = {
      phoneNumber: user.phoneNumber,
      channel:'1'
    };
    dispatch(sendOtpToUser(data));

    // const data = {
    //   amount: amount,
    //   recipientAccount: walletAccount,
    //   otp: pin,
    //   clientRequestId: requestIdGenerator(),
    // };
    // dispatch(withdrawToWallet(data));
  };

  const handlePinSubmission = (e:any)=> {
    setAuthenticate(false)
    setIsSummary(true)
  }

  const handleBank = (e: any) => {
    e.preventDefault();    
    setLoading(true);
    // setSubmitted(true);
    setIsCommission(true)
    setCounter(60)
    setIsBank(true)

    const data = {
      phoneNumber: user.phoneNumber,
      channel:'1'
    };
    dispatch(sendOtpToUser(data));
    
  };

  

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });

    callCommissions();

    return () => {
      dispatch({
        type: "AGENT",
        payload: {},
      });
      dispatch({
        type: "DASHBOARD",
        payload: {},
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page]);

  React.useEffect(() => {
    if (otp && Object.entries(otp).length !== 0) {
      if(otp.exists) {
        setAuthenticate(true)
        setValidatedEntityId(otp.validatedEntityId)
      }
      
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otp]);
  React.useEffect(() => {
    if (cashout && Object.entries(cashout).length !== 0) {
      setWalletAccount(cashout.agentPhoneNumber!==null?cashout.agentPhoneNumber:cashout.phoneNumber);
      setCashoutAccount(cashout.accountNumber + ` (${cashout.bankName})`);
      setAgentName(cashout.agentName!==null?cashout.agentName:cashout.aggregatorName);
      setAccountName(cashout.accountName);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cashout]);

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });

        setSubmitted(false);
        setLoading(false);
        setAuthenticate(false)
        setAuthenticationOtp('')
        setSubmittedOtp(false);
        setIsCommission(false)
        setIsBank(false)
        setPin('')
        closePinModal();
        setLoadingCommissionCashout(false)



      } else {
        setAmount("");

        closeModal();
        closePinModal();
        // handleRefresh();
        setSubmitted(false);

        if (account !== "bank") {
          setTitle("Withdrawal to bank successful");
          setSubtitle(
            "This transaction would appear on your My Transactions Page of the dashboard"
          );
        } else {
          setTitle("Withdrawal to wallet successful");
          setSubtitle(
            "This transaction would appear on your My Wallet Page of the dashboard"
          );
        }

        dispatch({
          type: "STATUS_ALERT",
          payload: true,
        });

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);
  const handleDownloadModal = () => {
    sethandleWithDrawModal(true);
    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
  };

  return (
    <React.Fragment>


<div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar />
      </div>
      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          // overflow: "auto",
          backgroundColor: PrimaryTheme.white,

          // height: '100vh',
        }}
      >
        <div
          className="col-md-11 ml-auto mr-auto p-0 comission-metrics-cover"
          style={{
            backgroundColor: PrimaryTheme.white,

            height: "100vh",
            position: "relative",

            // zIndex: 1000,
          }}
        >
          <h1
            className="mb-5"
            style={{
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              textTransform: "uppercase",
              fontSize: PrimaryTheme.fontSizes?.subtitle,
            }}
          >
            Commissions
            <div className="comission-balance" style={{ float: "right" }}>
              {/* Total Commissions :{" "}
              {dashboard?.totalCommission
                ? getCurrency(dashboard?.totalCommission)
                : getCurrency("0")} */}
                <button
                style={{
                  paddingLeft: "48px",
                  paddingRight: "48px",
                  paddingTop: '12px',
                  paddingBottom: '12px',
                  border: "none",
                  fontSize: PrimaryTheme.fontSizes?.normal,
                  backgroundColor: PrimaryTheme.primary,
                  color: PrimaryTheme.white,
                  borderRadius: "4px",
                }}
                onClick={handleWithdrawal}
              >
                Commission cashout
              </button>
            </div>
          </h1>

          {/* cards  */}

          <div
            style={{ marginBottom: "20px" }}
            className="comission-card-on-mobile"
          >
            {/* <MetricsCard
              id="first"
              title="Today"
              value={
                dashboard?.todayCommission
                  ? getCurrency(dashboard?.todayCommission)
                  : getCurrency("0")
              }
              isValue
              // buttonTitle="Recommend POS"
              // buttonColor={PrimaryTheme.success}
            /> */}
            <MetricsCard
              id="first"
              title="Commission Balance"
              // value={
              //   dashboard?.todayCommission
              //     ? getCurrency(dashboard?.todayCommission)
              //     : getCurrency("0")
              // }
              value={
                dashboard
                  ? dashboard?.aggregatorCommissionBalance
                    ? getCurrency(dashboard?.aggregatorCommissionBalance)
                    : getCurrency("0")
                  : getCurrency("0")
              }
              isValue
              background={PrimaryTheme.warn}
              // buttonTitle="Recommend POS"
            />
          </div>

          <div
            style={{ marginBottom: "20px" }}
            className="comission-card-on-mobile"
          >
            {/* <MetricsCard
              id="second"
              value={
                dashboard
                  ? dashboard?.aggregatorCommissionBalance
                    ? getCurrency(dashboard?.aggregatorCommissionBalance)
                    : getCurrency("0")
                  : getCurrency("0")
              }
              background={PrimaryTheme.warn}
              title="Current Balance"
            /> */}
            <MetricsCard
              handleTodayDropdown
              id="second"
              value={
                dashboard?.todayCommission
                  ? getCurrency(dashboard?.todayCommission)
                  : getCurrency("0")
              }
              // value={
              //   dashboard
              //     ? dashboard?.aggregatorCommissionBalance
              //       ? getCurrency(dashboard?.aggregatorCommissionBalance)
              //       : getCurrency("0")
              //     : getCurrency("0")
              // }
              title="Commissions earned"
            />
          </div>

          {/* <div
            style={{ marginBottom: "20px" }}
            className="comission-card-on-mobile"
          >
            <div
              className="border-radius box-shadow p-3 overflow-hidden text-center"
              style={{}}
            >
              <h6
                className="text-center mb-4"
                style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  // fontSize: PrimaryTheme.fontSizes?.subtitle,
                  color: PrimaryTheme.dark,
                  textTransform: "uppercase",
                }}
              >
                {"Withdraw Commissions"}
              </h6>
              <button
                onClick={handleWithdrawal}
                className="btn btn-lg badge-pill btn-primary w-75 mt-1"
              >
                Withdraw
              </button>
            </div>
          </div> */}
          <div className="comission-card-on-desktop">
            <div className="row mb-5">
              <div className="col-md-4 col-12">
                {/* <MetricsCard
                  id="first"
                  title="Today"
                  value={
                    dashboard.todayCommission
                      ? getCurrency(dashboard.todayCommission)
                      : getCurrency("0")
                  }
                  isValue
                  // buttonTitle="Recommend POS"
                  // buttonColor={PrimaryTheme.success}
                /> */}
                <MetricsCard
                  id="first"
                  title="Commission Balance"
                  // value={
                  //   dashboard.todayCommission
                  //     ? getCurrency(dashboard.todayCommission)
                  //     : getCurrency("0")
                  // }
                  value={
                    dashboard
                      ? dashboard?.aggregatorCommissionBalance
                        ? getCurrency(dashboard?.aggregatorCommissionBalance)
                        : getCurrency("0")
                      : getCurrency("0")
                  }
                  isValue
                  background={PrimaryTheme.warn}
                  // buttonTitle="Recommend POS"
                />
              </div>

              <div
                className="col-md-4 col-12 "
                style={{
                  height: "auto",
                  position: "relative",
                }}
              >
                {/* <MetricsCard
                  id="second"
                  value={
                    dashboard
                      ? dashboard.aggregatorCommissionBalance
                        ? getCurrency(dashboard.aggregatorCommissionBalance)
                        : getCurrency("0")
                      : getCurrency("0")
                  }
                  background={PrimaryTheme.warn}
                  title="Current Balance"
                /> */}
                <MetricsCard
                  handleTodayDropdown
                  id="second"
                  // value={
                  //   dashboard
                  //     ? dashboard.aggregatorCommissionBalance
                  //       ? getCurrency(dashboard.aggregatorCommissionBalance)
                  //       : getCurrency("0")
                  //     : getCurrency("0")
                  // }
                  value={
                    dashboard?.todayCommission
                      ? getCurrency(dashboard?.todayCommission)
                      : getCurrency("0")
                  }
                  title="Commissions earned"
                />
              </div>

              {/* <div
                className="col-md-4 col-12"
                style={{
                  height: "auto",
                  position: "relative",
                }}
              >
                <div
                  className="border-radius box-shadow p-3 overflow-hidden text-center"
                  style={{
                    minHeight: 120,
                    backgroundColor: PrimaryTheme.white,
                  }}
                >
                  <h6
                    className="text-center mb-4"
                    style={{
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                      // fontSize: PrimaryTheme.fontSizes?.subtitle,
                      color: PrimaryTheme.dark,
                      textTransform: "uppercase",
                    }}
                  >
                    {"Withdraw Commissions"}
                  </h6>
                  <button
                    onClick={handleWithdrawal}
                    className="btn btn-lg badge-pill btn-primary w-75 mt-1"
                    disabled={!canWithdrawCommission ? true : false}
                  >
                    Withdraw
                  </button>
                </div>
              </div> */}
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-md-12">
              <Filters
                onDownload={handleDownloadModal}
                name="Download Transactions"
                hasDownloads
                hasSearch
                searchState={searchState}
                onClear={handleClear}
                handleSearch={(e: any) => setSearchState(e.target.value)}
              />
            </div>
          </div>

          <div className="row " style={{ paddingBottom: "100px" }}>
            <div className="col-md-12 mb-3">
              {list ? (
                <React.Fragment>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="thead-primary">
                        <tr className="text-center">
                          <th scope="col">S/N</th>
                          <th scope="col">Type</th>
                          <th scope="col">Reference</th>
                          <th scope="col">Date</th>
                          <th scope="col">Agent</th>
                          <th scope="col">Phone Number</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Commission</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.length !== 0 &&
                          list?.map((item: any, index: number) => (
                            <tr key={index} className="text-center">
                              <th scope="row">{getIndexSeed(index)}</th>
                              <td style={{ display: "flex" }}>
                                <div className="row m-0 justify-content-start align-items-center">
                                  <Icon
                                    fontSize="small"
                                    style={{
                                      color: PrimaryTheme.lightGreen,
                                      marginRight: 5,
                                    }}
                                  >
                                    fiber_manual_record
                                  </Icon>
                                </div>
                                {item.transactionTypeName
                                  ? item.transactionTypeName
                                  : "-"}
                              </td>
                              <td>
                                <div className="row m-0 justify-content-start align-items-center">
                                  <Icon
                                    fontSize="small"
                                    style={{
                                      color: PrimaryTheme.lightGreen,
                                      marginRight: 5,
                                    }}
                                  >
                                    fiber_manual_record
                                  </Icon>
                                </div>
                                {item.transactionReference
                                  ? item.transactionReference
                                  : "-"}
                              </td>
                              <td>
                                {item.createdOn
                                  ? getDateTime(item.createdOn)
                                  : "-"}
                              </td>
                              <td>{item.agentName ? item.agentName : "-"}</td>
                              <td>
                                {item.phoneNumber ? item.phoneNumber : "-"}
                              </td>
                              <td>
                                {item.amount ? getCurrency(item.amount) : "-"}
                              </td>
                              <td>
                                {item.commissionAmount
                                  ? getCurrency(item.commissionAmount)
                                  : getCurrency("0")}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  {list.length === 0 && (
                    <React.Fragment>
                      <p className="text-center mt-3 text-dark w-100">
                        No result
                      </p>
                    </React.Fragment>
                  )}

                  <div className="col-md-12 p-0">
                    {commissions.total > pageSize && (
                      <PaginationControlled
                        onPageSizeChange={handlePageSizeChange}
                        onChange={handleChange}
                        page={page}
                        total={commissions.total && commissions.total}
                        pageSize={pageSize}
                      />
                    )}
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
        {handleWithDrawModal ? (
          <AlertModal showClose maxWidth="md">
            <DownloadTransactionForm />
          </AlertModal>
        ) : (
          <div>
            <WithdrawModal
              withdrawType="Commission"
              detailsTitle="AGGREGATOR WALLET ACCOUNT"
              pin={pin}
              setPin={setPin}

              NewCashout={NewCashout}
              PrimaryTheme={PrimaryTheme}
              cashout={cashout}
              cashoutAccount={cashoutAccount}
              account={account}
              setAccount={setAccount}
              setAccountName={setAccountName}
              walletAccount={walletAccount}
              setWalletAccount={setWalletAccount}
              agentName={agentName}
              setAgentName={setAgentName}
              accountName={accountName}
              submitted={submitted}
              handleSubmit={handleSubmit}
              loading={loading}
              setLoading={setLoading}
              loadingCommissionCashout={loadingCommissionCashout}
              setLoadingCommissionCashout={setLoadingCommissionCashout}
              hasCashout={hasCashout}
              handleBank={handleBank}
              handlePinSubmission={handlePinSubmission}
              authenticate={authenticate}
              history={history}
              setAmount={setAmount}
              amount={amount}
              validatedEntityId={validatedEntityId}
              setAuthenticate={setAuthenticate}
              title={title}
              subtitle={subtitle}
              handleRefresh={handleRefresh}
              setAuthenticationOtp={setAuthenticationOtp}
              authenticationOtp={authenticationOtp}
              setSubmittedOtp={setSubmittedOtp}
              submittedOtp={submittedOtp}
              counter={counter}
              setCounter={setCounter}
              isCommission={isCommission}
              setIsCommission={setIsCommission}
              isBank={isBank}
              setIsBank={setIsBank}
              isSummary={isSummary}
              setIsSummary={setIsSummary}
            />
            {/* <WithdrawCommissionsAlertPopup
              NewCashout={NewCashout}
              PrimaryTheme={PrimaryTheme}
              cashout={cashout}
              cashoutAccount={cashoutAccount}
              account={account}
              setAccount={setAccount}
              setAccountName={setAccountName}
              walletAccount={walletAccount}
              setWalletAccount={setWalletAccount}
              agentName={agentName}
              setAgentName={setAgentName}
              accountName={accountName}
              submitted={submitted}
              pin={pin}
              setPin={setPin}
              handleSubmit={handleSubmit}
              loading={loading}
              hasCashout={hasCashout}
              handleBank={handleBank}
              authenticate={authenticate}
              history={history}
              setAmount={setAmount}
              amount={amount}
              validatedEntityId={validatedEntityId}
              setAuthenticate={setAuthenticate}
              title={title}
              subtitle={subtitle}
              handleRefresh={handleRefresh}
              setAuthenticationOtp={setAuthenticationOtp}
              authenticationOtp={authenticationOtp}
              setSubmittedOtp={setSubmittedOtp}
              submittedOtp={submittedOtp}
              counter={counter}
              setCounter={setCounter}
              isCommission={isCommission}
              setIsCommission={setIsCommission}
              isBank={isBank}
              setIsBank={setIsBank}
            /> */}

            <StatusAlert
              title={title}
              subtitle={subtitle}
              buttonTitle={"Close"}
              onClick={handleRefresh}
            ></StatusAlert>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
